import UIInlineLabel from 'UIComponents/form/UIInlineLabel';
import FormattedMessage from 'I18n/components/FormattedMessage';
import styled from 'academy-common-lib/utils/Styling';
import { RouterSelectSingle } from '../../filters';
import { jsx as _jsx } from "react/jsx-runtime";
const AssignedByFilter = styled.span.withConfig({
  displayName: "PlaylistAssignmentsAssignedByFilter__AssignedByFilter",
  componentId: "sc-17f0b42-0"
})(["[role='button']{padding:0 !important;}"]);
const PlaylistAssignmentsAssignedByFilter = () => {
  return /*#__PURE__*/_jsx(AssignedByFilter, {
    children: /*#__PURE__*/_jsx(UIInlineLabel, {
      label: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "learningCenter.topFilters.assignedBy.filterTitle"
      }),
      children: /*#__PURE__*/_jsx(RouterSelectSingle, {
        filterType: "assignedBy",
        menuWidth: 170,
        style: {
          padding: '0 !important'
        }
      })
    })
  });
};
export default PlaylistAssignmentsAssignedByFilter;